import { createFileRoute } from "@tanstack/react-router";
import SearchLab from "@/pages/SearchLab";

export const Route = createFileRoute("/search-lab")({
  head: () => ({
    meta: [
      { title: "Smart Search Lab | Rex & Sons RVs" },
      { name: "description", content: "Internal test bench for the Rex & Sons smart search engine." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Smart Search Lab" },
      { property: "og:description", content: "Internal search engine test bench." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: SearchLab,
});
